/** @jsxImportSource @emotion/react */
import type { ComponentProps } from 'react';

import { CommonToggle } from '@kaiizen/kai-shiki/react';
import {
  SETTINGS_WIDGET_TOGGLE_KNOB_OFF_STYLE,
  SETTINGS_WIDGET_TOGGLE_KNOB_STYLE,
  SETTINGS_WIDGET_TOGGLE_TRACK_OFF_STYLE,
  SETTINGS_WIDGET_TOGGLE_TRACK_STYLE,
} from './SettingsStyleLib';

type SettingsToggleProps = Omit<
  ComponentProps<typeof CommonToggle>,
  'trackCss' | 'knobCss'
>;

/**
 * The settings surface's toggle: the design's 40x22 ink pill, in one place (KAIDEV-4345).
 *
 * `CommonToggle` left to itself renders the styleguide's green success track, which belongs to
 * the interim design. Each tab that remembered to override it repeated the same four constants;
 * the ones that did not - the Modifiers cards and the Notifications rows - stayed green. The
 * tokens it is drawn in come from the kai-shiki seam, as everything on this surface should.
 */
export const SettingsToggle = ({ checked, ...props }: SettingsToggleProps) => (
  <CommonToggle
    checked={checked}
    trackCss={[SETTINGS_WIDGET_TOGGLE_TRACK_STYLE, !checked && SETTINGS_WIDGET_TOGGLE_TRACK_OFF_STYLE]}
    knobCss={[SETTINGS_WIDGET_TOGGLE_KNOB_STYLE, !checked && SETTINGS_WIDGET_TOGGLE_KNOB_OFF_STYLE]}
    {...props}
  />
);
